module.exports = __webpack_public_path__ + "static/media/7.00e8a339.jpg";